export const NAME = 'management';